export const API_BASE_URL_V1 = '/api/v1';

export default {
    ANALYTICS: `${API_BASE_URL_V1}/analytics`,
    SERVICE: `${API_BASE_URL_V1}/service-offerings`,
    MEMBERS: `${API_BASE_URL_V1}/members`,
}
